import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import de from './locales/de.json'
import en from './locales/en.json'
import it from './locales/it.json'
import es from './locales/es.json'

i18n.use(initReactI18next).init({
  resources: {
    de: { translation: de },
    en: { translation: en },
    it: { translation: it },
    es: { translation: es },
  },
  lng: 'de', // default, overridden by TenantProvider
  fallbackLng: 'de',
  interpolation: {
    escapeValue: false, // React already escapes
  },
})

// Keep <html lang> in sync: browsers decide whether to offer/auto-apply translation from it
// (a page marked lang="de" showing Italian was machine-translated into 'Grazie, the document is firm.')
i18n.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') document.documentElement.lang = lng
})
if (typeof document !== 'undefined') document.documentElement.lang = i18n.language

export default i18n
